export const findRubricById = (rubrics, id) => {
  for (const key in rubrics) {
    if (rubrics[key].id === id) {
      return rubrics[key];
    }
  }
};
